/* eslint-disable react-hooks/exhaustive-deps */
import "./Style.css";
import Modal from "react-bootstrap/Modal";
import { ClipLoader } from "react-spinners";
import { RxCross2 } from "react-icons/rx";
import { Apiurl, parseData } from "../../Pages/utils/page";
import axios from "axios";
import { useEffect } from "react";

const LoginModal = ({
  showLoginModal,
  handleClose,
  
  inputData,
  setinputData,
  handleSendOtp,
  showOtpInput,
  handleSubmitOtp,
  showLoading,
  resendTimer,
  showNameInput,
  handleNameUpdate,
  formName,
  setFormName,
  showLoginModalHome,
  isSignup,
  signupData,
  setSignupData,
  handleSignup,
  setIsSignup,
  showOtpScreen,
  loadingLogin,
  handleVerifyOtp,
  phoneResendTimer,
  handleResendPhoneOtp,
  setShowOtpScreen,
  setShowOtpInput,
  isTermsChecked,
  setIsTermsChecked,
  showTermsModal,
  setShowTermsModal,
  setTermsAndConditions,
termsAndConditions
}) => {
  const handleKeyDown = (e, callback) => {
    if (e.key === "Enter") {
      e.preventDefault();
      callback();
    }
  };

   const getTermsandConditions = () => {
      const option = {
        method: "GET",
        headers: {
          Accept: "*/*",
        },
        url: `${Apiurl()}/api/UserAccount/GetActiveLoginPolicy`,
      };
      axios(option)
        .then((response) => {
          const data = parseData(response?.data?.result);
          setTermsAndConditions(data)
        })
        .catch((error) => {
          
        });
    };
    useEffect(()=>{
      getTermsandConditions();

    },[])
    
  return (
    <div className={"Login-modal-main-container"}>
      <></>
      <Modal
        backdrop="static"
        className={"Login-modal-outter-container"}
        show={showLoginModal || showLoginModalHome}
        onHide={handleClose}
        animation={false}
      >
        
        <Modal.Body>
          {isSignup ? ( 
            <>
              {!showOtpScreen ? (
                <>
                <div>
                    <RxCross2
                      className="cross-icon"
                      aria-label="Close"
                      onClick={() => {
                        handleClose();
                      }}
                    />
                  </div>
                  <h2 className="login-header">Signup</h2>

                  <input
                    className="form-control input-pd-spc"
                    placeholder="Full Name"
                    value={signupData.name}
                    onChange={(e) =>
                      setSignupData({ ...signupData, name: e.target.value })
                    }
                    onKeyDown={(e) => handleKeyDown(e, handleSignup)}
                  />

               
                  <input
                    className="form-control input-pd-spc"
                    placeholder="Phone Number"
                    value={signupData.phone}
                    style={{ marginTop: "5px", marginBottom: "2px" }}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      if (value.length <= 10) {
                        setSignupData({ ...signupData, phone: value });
                      }
                    }}
                    onKeyDown={(e) => handleKeyDown(e, handleSignup)}
                  />
                  <input
                    className="form-control input-pd-spc"
                    style={{ marginTop: "5px" }}
                    placeholder="Referral Code (Optional)"
                    value={signupData.referByUserCode}
                    onChange={(e) =>
                      setSignupData({
                        ...signupData,
                        referByUserCode: e.target.value,
                      })
                    }
                    onKeyDown={(e) => handleKeyDown(e, handleSignup)}
                  />
                  {/* Terms & Conditions */}
<div className="terms-wrapper">
  <input
    type="checkbox"
    id="terms"
    checked={isTermsChecked}
    onChange={(e) => setIsTermsChecked(e.target.checked)}
  />
  <label htmlFor="terms">
    I accept the{" "}
    <span
      className="terms-link"
      onClick={() => setShowTermsModal(true)}
    >
      Terms & Conditions
    </span>
  </label>
</div>
                  {loadingLogin === "otpsent" ? (
                    <ClipLoader loading size={15} 
                    
                          color="white"
                    />
                  ) : (
                    <button
                      className="submit-otp-button"
                      onClick={handleSignup}
                    >
                      Signup
                    </button>
                  )}
                </>
              ) : (
                <>
                  <h2 className="login-header">Verify OTP</h2>

                 
              
                  

                 
                  <input
                    className="form-control input-pd-spc"
                    value={signupData.phone}
                    readOnly
                    style={{ marginTop: "5px" }}
                  />
                  {phoneResendTimer > 0 ? (
                    <p style={{ textAlign: "right" }}>
                      Resend in:{" "}
                      {String(Math.floor(phoneResendTimer / 60)).padStart(
                        2,
                        "0"
                      )}
                      :{String(phoneResendTimer % 60).padStart(2, "0")}
                    </p>
                  ) : (
                    <>
                      {loadingLogin === "phoneresend" ? (
                        <ClipLoader loading size={15} 
                          color="white"
                        
                        />
                      ) : (
                        <p style={{ textAlign: "right" }}>
                          Didn’t receive Mobile OTP?{" "}
                          <span
                            style={{
                              color: "blue",
                              cursor: "pointer",
                              textDecoration: "underline",
                            }}
                            onClick={handleResendPhoneOtp}
                          >
                            Resend
                          </span>
                        </p>
                      )}
                    </>
                  )}

                  {/* Phone OTP */}
                  <input
                    className="form-control input-pd-spc"
                    placeholder="Enter Mobile OTP"
                    value={signupData?.phoneOtp}
                    onChange={(e) =>
                      setSignupData({ ...signupData, phoneOtp: e.target.value })
                    }
                    onKeyDown={(e) => handleKeyDown(e, handleVerifyOtp)}
                    style={{ marginTop: "5px" }}
                  />
                  {loadingLogin === "otpverify" ? (
                    <ClipLoader loading size={15} 
                          color="white"
                    />
                  ) : (
                    <button
                      className="submit-otp-button"
                      onClick={() => handleVerifyOtp()}
                    >
                      Submit OTP
                    </button>
                  )}
                </>
              )}
            </>
          ) : (
            <>
              {showNameInput ? (
                <>
                  <h2 className="login-header">User Details</h2>

                  <p>
                    Otp verification Successfull. Please fill details below.
                  </p>
                  <div className="form-feild-spc">
                    <input
                      type="text"
                      className="form-control input-pd-spc"
                      placeholder="Enter your name"
                      autoComplete="off"
                      value={formName || ""}
                      onChange={(e) => setFormName(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, handleNameUpdate)}
                    />
                    <button
                      className="submit-otp-button"
                      disabled={showLoading === "profile"}
                      onClick={handleNameUpdate}
                    >
                      {showLoading === "profile" ? (
                        <ClipLoader
                          className="main_loader_home"
                          loading
                          size={15}
                          color="green"
                        />
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div>
                    <RxCross2
                      className="cross-icon"
                      aria-label="Close"
                      onClick={() => {
                        handleClose();
                      }}
                    />
                  </div>
                  <h2 className="login-header">Login</h2>
                  <div className="form-feild-spc">
                    {showOtpInput ? (
                      // OTP Input Field
                      <>
                        <input
                          type="number"
                          className="form-control input-pd-spc"
                          placeholder="Enter OTP"
                          autoComplete="off"
                          maxLength={4}
                          value={inputData?.Otp || ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            // Allow only digits
                            if (/^\d*$/.test(value)) {
                              setinputData({
                                ...inputData,
                                Otp: e?.target?.value,
                              });
                            }
                          }}
                          onKeyDown={(e) => handleKeyDown(e, handleSubmitOtp)}
                        />
                        {resendTimer > 0 ? (
                          <p
                            style={{
                              marginTop: "0 px",
                              marginBottom: "2px",
                              textAlign: "right",
                            }}
                          >
                            Resend in:{" "}
                            {String(Math.floor(resendTimer / 60)).padStart(
                              2,
                              "0"
                            )}
                            :{String(resendTimer % 60).padStart(2, "0")}
                          </p>
                        ) : (
                          <p
                            style={{
                              marginTop: "0 px",
                              marginBottom: "2px",
                              textAlign: "right",
                            }}
                          >
                            Didn't receive OTP?{" "}
                            {showLoading === "otpsent" ? (
                              <>
                                <ClipLoader
                                  className="main_loader_home"
                                  loading
                                  size={15}
                          color="white"

                                />
                              </>
                            ) : (
                              <span
                                style={{
                                  color: "blue",
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                }}
                                onClick={handleSendOtp}
                              >
                                Resend
                              </span>
                            )}
                          </p>
                        )}
                      </>
                    ) : (
                      // Email or Phone Input Field
                      <input
                        type="text"
                        className="form-control input-pd-spc"
                        placeholder="Enter Email or Phone Number"
                        autoComplete="off"
                        value={inputData?.input || ""}
                        onChange={(e) => {
                          const value = e.target.value.trim();

                          setinputData((prev) => ({
                            ...prev,
                            input: value, // store raw input
                            Email: "", // reset classification
                            Mobile: "",
                          }));
                        }}
                        onKeyDown={(e) => handleKeyDown(e, handleSendOtp)}
                      />
                    )}
                    
                  </div>
                  {!showOtpInput ? (
                    <button
                      className="submit-otp-button"
                      disabled={showLoading === "otpsent"}
                      onClick={handleSendOtp}
                    >
                      {showLoading === "otpsent" ? (
                        <ClipLoader
                          className="main_loader_home"
                          loading
                          size={15}
                          color="white"

                        />
                      ) : (
                        "Login"
                      )}
                    </button>
                  ) : (
                    <button
                      className="submit-otp-button"
                      disabled={showLoading === "submitotp"}
                      onClick={handleSubmitOtp}
                    >
                      {showLoading === "submitotp" ? (
                        <ClipLoader
                          className="main_loader_home"
                          loading
                          size={15}
                          color="white"
                        />
                      ) : (
                        "Submit OTP"
                      )}
                    </button>
                  )}
                 
             
                </>
              )}
            </>
          )}
          {isSignup ? (
            <p
              className="text-center mt-3"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                gap: "5px",
                color:"#797B7C"

              }}
            >
              Already have an account?
              <span
                className="link-refer-login-butt"
                // style={{ marginLeft: "5px" }}
                onClick={() => {
                  setIsSignup(false);
        setShowOtpScreen(false);

                  setSignupData({
                    ...signupData,
                    name: "",
                    email: "",
                    phone: "",
                    emailOtp: "",
                    phoneOtp: "",
                  });
                }}
              >
                Login
              </span>
            </p>
          ) : (
            <p
              className="text-center mt-3"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                gap: "5px",
                color:"#797B7C"
              }}
            >
              Don't have an account?
              <span
                className="link-refer-login-butt"
                style={{ marginLeft: "5px" }}
                onClick={() => {
                  setIsSignup(true);
                  setinputData({
                    ...inputData,
                    Email: "",
                    Mobile: "",
                    Otp: "",
                    input: "",
                    ReferCode: "",
                  });
                  setShowOtpInput(false);
                }}
              >
                Signup
              </span>
            </p>
          )}
        </Modal.Body>
      </Modal> 

      {showTermsModal && (
           <Modal
        backdrop="static"
        className="terms-condition-signup-modal"
        show={showTermsModal}
        onHide={()=>setShowTermsModal(false)}
        animation={false}
      >
        <Modal.Header className="Login-modal-header-section" closeButton>
          Terms & Conditions
        </Modal.Header>
        <Modal.Body>
          {termsAndConditions ? (
          <div
            dangerouslySetInnerHTML={{ __html: termsAndConditions?.TermsAndCondition }}
          />
        ) : (
          <p>Loading...</p>
        )}
        </Modal.Body>
      </Modal> 

)}
    </div>
  );
};

export default LoginModal;
